import type { HelpFile } from '../../types/help'
import { IdentityManagementTestIds } from '../../../testids/IdentityManagementTestIds'

export const identityManagementHelp: HelpFile = {
  docPage: '/docs/identity/overview',
  texts: {
    [IdentityManagementTestIds.identityManagementWelcomeCard]:
      'Startseite des Identitäts-Managements — wählen Sie ein Werkzeug aus der Seitenleiste: Parteien, Identitäten, Konten und Onboarding.',
  },
}
